import type { FaireProductEntity } from "../../entity_types/product";

export const p_jgkmj9u2uh: FaireProductEntity = {
  token: "p_jgkmj9u2uh",
  type: "product",
  name: "Cosbai - Geometric Lace Botanical & Animal Canvas Tote",
  brandToken: "b_qrthtbpuwu",
  brandName: "Funkyrel® Atzbranding Limited",
  imageUrl:
    "https://cdn.faire.com/fastly/1e0001f52ece111f00d9c5515dbd41b377e22da42944e7579affc1d25e7a8567.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/559e4e8c5a06922b01be98020e9c512b843ea7cf3a0565df006e76c291f4f4a6.jpeg",
    "https://cdn.faire.com/fastly/c70d988384de25a665d1d3889ddc9800b67a82fc2e1cb722f6b04fee3ec14e78.jpeg",
    "https://cdn.faire.com/fastly/290ad237d14a0d3b6f1075954e24202b7f0031fc6085c32270ea360169f7abe6.jpeg",
    "https://cdn.faire.com/fastly/80fb81c3bfc4b9db5bd0d63b05869f49ef80e77c4a419a433a2374deb78d1630.jpeg",
    "https://cdn.faire.com/fastly/b335d1f204a6c7e1d8e4bc1ef39d8b250ed5dd321ff80cb6517dc897b001209e.jpeg",
    "https://cdn.faire.com/fastly/b6ec999d5eece5a2040ea6dc30eba092b6e6ba712788fa0b5353533849bcc956.jpeg",
    "https://cdn.faire.com/fastly/60e04cbe64ee66ec6e337d259e771448696662ca46a02dd149bb35ff4a4ab141.jpeg",
    "https://cdn.faire.com/fastly/86efabc63ec9b7ad23a12ff3fc7e9da3df90f4dc6bdbb4ab2c1adae73926ed49.jpeg",
    "https://cdn.faire.com/fastly/807d43be7b39d6417504c9dd5f38c4e941ac54c42dacfc2f150d0d8ab84ed417.jpeg",
    "https://cdn.faire.com/fastly/2441144eea72e154285fd7979a46e735990df436d3d3221d60f3a9cf7cb385fc.jpeg",
    "https://cdn.faire.com/fastly/2a4b6e7a50754f09f45ff152200d004e4f5cf9d6de7279f34094fc421bf00a16.jpeg",
    "https://cdn.faire.com/fastly/0bd6f967c8aeda647e3a99532fb80d543d98cea3b1492f3fae44bbe55cdb15d8.jpeg",
  ],
  priceDollars: 10.39,
  description:
    "This vibrant and stylish canvas tote features a unique geometric lace design paired with captivating botanical and animal motifs, making it both eye-catching and durable.\n\n Bold Geometric & Nature-Inspired Design: Combines intricate geometric lace patterns with beautiful botanical and animal illustrations, adding a touch of nature to your everyday look.\n Durable Canvas Material: Crafted from high-quality canvas, this tote is sturdy and built to last, perfect for daily use.\n Add a touch of nature-inspired elegance to your wardrobe with this Geometric Lace Botanical & Animal Canvas Tote, a practical and stylish accessory for any occasion. \nOur popular brand offers UPC-coded, retail-ready products, ensuring quality and shopping ease. Each item is crafted for excellence and ready for immediate retail. For inquiries, our responsive customer service is at your service, guaranteeing a seamless and supportive customer experience.\n",
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:02:09.673Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
